import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  IStoreProductBatchesGetAllParams,
  IStoreProductBatchesResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IStoreProductBatchesResponse>>,
  IPathBaseParam,
  IPaginationParams & IStoreProductBatchesGetAllParams
>("stores.productBatches");

export const productBatches = {
  ...getAllApis,
};
